import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { BUY_TOUCHLESS, CALCULATE_PRICE } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { hasHigherProductLevelInProductInventorySelector, hasProductInProductInventorySelector } from './ProductInventorySelectors';
import { currentSkuIdForProductSelector } from './ProductsSelectors';
import { purchaseMotionsSelector } from './PurchaseMotionSelectors';
export const canUpgradeToProductLevelSuiteSelector = (state, {
  productLevel
}) => {
  const ownsHigherProductLevel = hasHigherProductLevelInProductInventorySelector(state, {
    productLevel
  });
  const crmSuiteProductsForProductLevel = CRM_SUITE_PRODUCTS[productLevel];
  const ownsAllProductLinesInProductLevel = crmSuiteProductsForProductLevel.every(productLine => hasProductInProductInventorySelector(state, {
    productAttributeFilters: {
      productLine,
      productLevel
    }
  }));
  const starterSkuIds = crmSuiteProductsForProductLevel.map(productLine => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel: STARTER
  }));
  const cannotPurchaseAnyStarterSkusTouchlessly = starterSkuIds.filter(skuId => skuId).every(skuId => {
    const purchaseMotions = purchaseMotionsSelector(state, {
      skuId
    });
    return !purchaseMotions.includes(BUY_TOUCHLESS) && !purchaseMotions.includes(CALCULATE_PRICE);
  });
  return !(ownsHigherProductLevel || ownsAllProductLinesInProductLevel || cannotPurchaseAnyStarterSkusTouchlessly);
};